import { render, staticRenderFns } from "./MonitorMessages.vue?vue&type=template&id=b7af19c4&"
import script from "./MonitorMessages.vue?vue&type=script&lang=ts&"
export * from "./MonitorMessages.vue?vue&type=script&lang=ts&"
import style0 from "./MonitorMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports